import { ReactComponent as BlogIcon } from '~/images/blog-svgrepo-com.svg'
import { ReactComponent as KBIcon } from '~/images/idea-bulb-learning-knowledge-education-book-idea-svgrepo-com.svg'
import { ReactComponent as LearningIcon } from '~/images/links-svgrepo-com.svg'

import { useNavigate } from 'react-router-dom'

import { Tile, TileHeader, TileListContent, TileListItem } from '../Tile'

const QuickLinksTile = () => {
  const links = [
    {
      title: 'Knowledge Base',
      icon: <KBIcon className="h-6 w-6" />,
      url: 'https://www.clouddirect.net/knowledge-base'
    },
    {
      title: 'Provide Training',
      icon: <LearningIcon className="h-6 w-6" />,
      url: '/training'
    },
    {
      title: 'Learning Hub',
      icon: <LearningIcon className="h-6 w-6" />,
      url: 'https://www.clouddirect.net/learning-hub'
    },
    {
      title: 'Blog',
      icon: <BlogIcon className="h-6 w-6" />,
      url: 'https://clouddirect.net/learning-hub?s=&media-type=blog'
    }
  ]

  const navigate = useNavigate()
  const handleNavigate = (url: string) => {
    if (url.startsWith('http')) {
      window.open(url, '_blank')
    } else {
      navigate(url)
    }
  }

  return (
    <Tile>
      <TileHeader>
        <TileHeader.Title>Quick Links</TileHeader.Title>
        <TileHeader.Subtitle>Internal & External Resources</TileHeader.Subtitle>
      </TileHeader>
      <TileListContent limit={links.length}>
        {links.map((link) => (
          <TileListItem key={link.title} onMouseDown={() => handleNavigate(link.url)}>
            <div className="flex items-center gap-3">
              {link.icon}
              <span className="text-sm font-medium">{link.title}</span>
            </div>
          </TileListItem>
        ))}
      </TileListContent>
    </Tile>
  )
}

export default QuickLinksTile
